module.exports = __webpack_public_path__ + "img/pin-stokrotka.937c3564.svg";